
import { ReducerRegistry } from '../base/redux';

import {
    PARTICIPANT_WHITE_BOARD_ID,
    SET_GENERICIFRAME_URL,
    SET_GENERICIFRAME_VISIBILITY_STATUS
} from './actionTypes';

const DEFAULT_STATE = {
    /**
     * URL for the shared document.
     */
    iframeUrl: undefined,

    /**
     * Whether or not GenericIFrame is currently visible.
     *
     * @public
     * @type {boolean}
     */
    visible: false,

    partId: null
};

/**
 * Reduces the Redux actions of the feature features/genericiframe.
 */
ReducerRegistry.register(
    'features/genericiframe',
    (state = DEFAULT_STATE, action) => {
        switch (action.type) {
        case SET_GENERICIFRAME_VISIBILITY_STATUS:
            return {
                ...state,
                visible: action.visible
            };

        case SET_GENERICIFRAME_URL:
            return {
                ...state,
                iframeUrl: action.iframeUrl
            };
        case PARTICIPANT_WHITE_BOARD_ID:

            return {
                ...state,
                partId: action.partId
            };

        default:
            return state;
        }
    }
);
